module.exports = __webpack_public_path__ + "static/logoN-637a7ff9d93173009e5fad27bcba5f29.svg";